import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'
import { imageUrl } from '../lib/images'

export default function About() {
  return (
    <div>
      <PageHeader
        badge="Non-profit, upolitisk og ikke-religiøs humanitær forening"
        title="Om Unges Fremtid"
        subtitle="Startet af ildsjæle, der brænder for at støtte og hjælpe sårbare og udsatte børn og unge mellem 10 og 29 år til et godt liv."
        breadcrumb={[{ label: 'Om Unges Fremtid' }]}
      />

      {/* OM UNGES FREMTID (Foto: COLOURBOX52763076) */}
      <section id="formaal" className="py-16 sm:py-24 bg-white border-b border-neutral-200 scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
                Vores formål og virke
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0c304d] tracking-tight">
                Om Unges Fremtid
              </h2>
              <div className="space-y-4 text-neutral-700 text-base sm:text-lg leading-relaxed">
                <p>
                  Unges Fremtid er en nonprofitorganisation, der arbejder for at hjælpe og styrke udsatte børn og unge til at få et meningsfyldt liv med stærke relationer i sunde fællesskaber, samt uddannelse og job.
                </p>
                <p>
                  Foreningens formål er at støtte og hjælpe sårbare og udsatte børn og unge mellem 10 og 29 år til et godt liv gennem udvikling af deres personlige, sociale, kulturelle, sproglige og faglige kompetencer.
                </p>
                <p>
                  Det sker gennem meningsfulde initiativer og målrettede projekter, hvor mentorindsatser ofte spiller en central rolle.
                </p>
              </div>

              <div className="p-6 bg-amber-50/80 rounded-2xl border border-amber-200/80 space-y-3">
                <p className="text-neutral-800 text-sm sm:text-base leading-relaxed">
                  <strong>Om vores logo:</strong> De to unge mennesker symboliserer fællesskab, relation og troen på, at alle unge kan noget og ingen skal stå alene.
                </p>
                <p className="text-neutral-800 text-sm sm:text-base leading-relaxed">
                  Træerne og planter står for vækst, håb og nye muligheder.
                </p>
                <p className="text-neutral-800 text-sm sm:text-base leading-relaxed">
                  Sammen fortæller logoet, at Unges Fremtid skaber grobund for, at unge kan vokse, udvikle sig og finde deres egen vej i livet.
                </p>
              </div>

              <div className="p-6 bg-white rounded-2xl border border-neutral-200/90 shadow-2xs space-y-3">
                <div className="flex items-center gap-2.5 text-[#0c304d] font-bold text-base">
                  <i className="fa-solid fa-list-check text-[#f39223]" aria-hidden="true" />
                  <span>Vores indsatser og kerneområder</span>
                </div>
                <p className="text-neutral-600 text-sm sm:text-base leading-relaxed">
                  Foreningen arbejder med målrettede projekter og mentorindsatser inden for trivsel, uddannelse, beskæftigelse og sunde fællesskaber for børn og unge i hele Danmark.
                </p>
                <div className="pt-1">
                  <Link
                    to="/vores-arbejde"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-[#f39223] hover:text-[#0c304d] transition-colors"
                  >
                    <span>Læs mere om de enkelte indsatsområder</span>
                    <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                  </Link>
                </div>
              </div>

              <div className="pt-2 flex flex-wrap gap-4">
                <Link
                  to="/vores-arbejde"
                  className="inline-flex items-center gap-2 bg-[#0c304d] hover:bg-[#16466e] text-white font-semibold text-sm px-6 py-3.5 rounded-full transition-colors cursor-pointer shadow-xs"
                >
                  <span>Se vores indsatser</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 bg-neutral-100 hover:bg-neutral-200 text-[#0c304d] font-semibold text-sm px-6 py-3.5 rounded-full transition-colors cursor-pointer"
                >
                  <span>Kontakt os</span>
                </Link>
              </div>
            </div>

            {/* Billede: COLOURBOX52763076 */}
            <div className="lg:col-span-5">
              <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-neutral-100">
                <img
                  src={imageUrl('/_assets/colourbox52763076.jpg', 'width=800,quality=85,format=auto')}
                  alt="Smilende ung pige der kigger over skulderen"
                  className="w-full h-[460px] object-cover"
                  style={{ objectPosition: '80% 50%' }}
                  width={500}
                  height={460}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VORES VÆRDIER */}
      <section id="vaerdier" className="py-16 sm:py-24 bg-[#faf9f6] scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-3">
            <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
              Værdigrundlag
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0c304d] tracking-tight">
              De værdier, vi arbejder ud fra
            </h2>
            <p className="text-neutral-600 text-base sm:text-lg">
              Vores værdier styrer hver eneste relation, mentorindsats og samtale med de unge.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-2xl p-7 border border-neutral-200/90 shadow-2xs">
              <div className="w-12 h-12 rounded-xl bg-sky-50 text-[#0c304d] flex items-center justify-center text-xl mb-5">
                <i className="fa-solid fa-handshake-angle text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-[#0c304d] mb-2">
                Nærvær og relationer
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Varig forandring skabes gennem tillidsfulde, trygge relationer. Vi møder de unge som hele mennesker.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-7 border border-neutral-200/90 shadow-2xs">
              <div className="w-12 h-12 rounded-xl bg-amber-50 text-[#0c304d] flex items-center justify-center text-xl mb-5">
                <i className="fa-solid fa-door-open text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-[#0c304d] mb-2">
                Rummelighed og respekt
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Vi møder den unge i øjenhøjde uden fordomme. Hos os er der plads til at være sårbar og lave fejl.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-7 border border-neutral-200/90 shadow-2xs">
              <div className="w-12 h-12 rounded-xl bg-emerald-50 text-[#0c304d] flex items-center justify-center text-xl mb-5">
                <i className="fa-solid fa-shield-halved text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-[#0c304d] mb-2">
                Tryghed og stabilitet
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Faste rammer og forudsigelighed giver mod til at udvikle sig og tro på fremtiden.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-7 border border-neutral-200/90 shadow-2xs">
              <div className="w-12 h-12 rounded-xl bg-rose-50 text-[#0c304d] flex items-center justify-center text-xl mb-5">
                <i className="fa-solid fa-sun text-[#f39223]" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-bold text-[#0c304d] mb-2">
                Håb og handlekraft
              </h3>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Vi fokuserer på ressourcer frem for begrænsninger og hjælper den unge med at genfinde livsglæden.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FORENINGSOPLYSNINGER & KONTAKT */}
      <section id="ledelse" className="py-16 sm:py-24 bg-white border-t border-neutral-200 scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <span className="text-xs font-bold uppercase tracking-wider text-[#f39223]">
              Foreningsoplysninger
            </span>
            <h2 className="text-3xl sm:text-4xl font-extrabold text-[#0c304d] tracking-tight">
              Unges Fremtid
            </h2>
            <p className="text-neutral-600 text-base sm:text-lg leading-relaxed">
              Vi udfører aktiviteter i hele Danmark og har base i Randers SØ.
            </p>

            <div className="mt-8 p-8 bg-neutral-50 rounded-3xl border border-neutral-200 text-left max-w-xl mx-auto space-y-4 shadow-sm">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-[#0c304d] text-white flex items-center justify-center text-xl font-bold shrink-0">
                  <i className="fa-solid fa-handshake-angle text-[#f39223]" aria-hidden="true" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#0c304d]">Unges Fremtid</h3>
                  <p className="text-sm text-neutral-500">CVR-nr: 46681606</p>
                </div>
              </div>

              <div className="pt-4 border-t border-neutral-200 space-y-3 text-sm text-neutral-700">
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-location-dot text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="block text-neutral-900">Adresse:</strong>
                    <span>Koglevej 36, 8960 Randers SØ</span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-phone text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="block text-neutral-900">Telefon (klik for opkald):</strong>
                    <a
                      href="tel:25778646"
                      className="hover:text-[#f39223] transition-colors font-bold text-[#0c304d] text-base"
                    >
                      25 77 86 46
                    </a>
                    <span className="block text-xs text-neutral-500">Telefontid: Hverdage 9.00 - 15.00</span>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-envelope text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="block text-neutral-900">E-mail (klik for mail):</strong>
                    <a
                      href="mailto:ungesfremtid@outlook.dk"
                      className="hover:text-[#f39223] transition-colors block text-[#0c304d] font-semibold"
                    >
                      ungesfremtid@outlook.dk
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-building-columns text-[#f39223] mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <strong className="block text-neutral-900">Bankoplysninger:</strong>
                    <span>Reg. nr. 6124</span>
                    <span className="block">Konto 0024431401</span>
                  </div>
                </div>
              </div>

              <div className="pt-4">
                <Link
                  to="/kontakt"
                  className="w-full inline-flex items-center justify-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-semibold text-sm py-3 px-6 rounded-full transition-colors cursor-pointer shadow-xs"
                >
                  <span>Gå til kontaktformularen</span>
                  <i className="fa-solid fa-paper-plane text-xs" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
